// ============================================================
// MIZUKARA global configuration
// Replace X_URL below with the real X (Twitter) profile URL.
// This is the ONLY place the X link is defined.
// ============================================================

export const X_URL = "https://x.com/Mizukara_AI";

// MIZUKARA token contract on ARC Mainnet
export const CA = "0xeFCEBe9EcCaA465457796960804E5656a3E2eE92";

export const LINKS = {
  x: X_URL,
  buy: "https://argus.world/token/0xeFCEBe9EcCaA465457796960804E5656a3E2eE92",
  chart: "https://dexscreener.com/arc/0x78788459e1f73e237b7ba03bbb58385bb6e8e4077b3c62df7a48cad86f44fb38",
  explorer: "https://arc-scan.org",
  rpc: "https://rpc.arc-scan.org",
};

export const ARC = {
  name: "ARC",
  networkLabel: "ARC MAINNET",
  chainId: 5042,
  symbol: "USDC",
  rpcHost: "rpc.arc-scan.org",
  explorerHost: "arc-scan.org",
};

export const ASSETS = {
  logo: "/assets/mizu-logo.png",
  banner: "/assets/mizu-ban.webp",
  art: "/assets/mizu-art.png",
};
